import { render, staticRenderFns } from "./ModListUserEditCommentComp.vue?vue&type=template&id=136b4382&scoped=true&"
import script from "./ModListUserEditCommentComp.vue?vue&type=script&lang=ts&"
export * from "./ModListUserEditCommentComp.vue?vue&type=script&lang=ts&"
import style0 from "./ModListUserEditCommentComp.vue?vue&type=style&index=0&id=136b4382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136b4382",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VContainer,VFlex,VIcon,VLayout,VTextarea})
